import {INewDeal} from "../../interfaces/IDeal";
import {Card, CardBody, CardProps, Flex, Heading, Table, Tbody, VStack} from "@chakra-ui/react";
import DealTime from "./dealtime";
import {ReactNode} from "react";
import {LastUpdated} from "../LastUpdated";
import omitKeys from "../../tools/omitKeys";
import {useTranslations} from "next-intl";

export interface DealViewProps extends CardProps {
    deal: INewDeal, stretch?: boolean, badge?: ReactNode, updatedAt?: number|undefined
}
export default function DealView(
    props: DealViewProps
) {
    let deal = props.deal
    let tHome = useTranslations("Home")
    const pureProps = omitKeys(props, ["deal", "stretch", "badge", "updatedAt"])
    return (
        <Card variant="filled" size="xs" gap={1} key={deal.description} w={props.stretch ? "100%" : "fit-content"} flexGrow={1} {...pureProps}>
            <CardBody>
                <Flex direction="column" gap={1} justify="space-between" h="100%">
                    <VStack align="start">
                        <Heading size="sm">
                            {/*{deal.description}*/}
                            {tHome("various_offers")}
                        </Heading>
                        {/*<Conditions conditions={deal.conditions}/>*/}
                        {props.badge}
                    </VStack>

                    <Table size="sm" border="none">
                        <Tbody>
                            <DealTime days={deal.days}/>
                        </Tbody>
                    </Table>
                    { props.updatedAt && <LastUpdated updatedAt={props.updatedAt}/> }
                </Flex>
            </CardBody>
        </Card>
    )
}